module.exports = __webpack_public_path__ + "static/2_1_search-2_DE-f7d041bd29412ecc20c5972d4a29daa1.svg";